const DEFAULT_COUNTRY = 1;
const DEFAULT_CHANNEL = 6;

export default { DEFAULT_COUNTRY, DEFAULT_CHANNEL };
